import { useEffect, useState } from "react";
import Tracking from "../../API/MICROSERVICES/TRACKING/tracking";
import AlertaCentral from "../../SHARED/CentralAlertas";

import axios from 'axios';
import { validar_ipv4 } from "../../SHARED/ipv4";


export default function Pruebas() {


    async function Prueba() {

        let ipv4: boolean = await validar_ipv4();

        console.log("ipv4 -> ", ipv4);

        console.log("Prueba");

        let orden = {
            of: 986974649,
        }

        Tracking.detalle(orden).then((resp: any) => {
            console.log(resp);
        });


        // AlertaCentral("Hola");

        AlertaCentral("ErrorIPV4");

    }


    useEffect(() => {

        return () => {
            Prueba();
        }

    }, [])



    return (
        <>

            <h4> Hola, soy un componente de prueba </h4>
        </>


    )
}